"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mustache = require("mustache");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var lodash_1 = require("lodash");
var InitialControlTemplateGenerator = /** @class */ (function () {
    function InitialControlTemplateGenerator() {
    }
    InitialControlTemplateGenerator.generateTemplate = function (controller, formType) {
        var template;
        var resultMap = {};
        // let inputBindingKeys: string[];
        var inputStateKeys;
        inputStateKeys = InitialControlTemplateGenerator.getStateTemplateKeys(controller, formType);
        lodash_1.forIn(controller.actions, function (value, key) {
            resultMap[key] = 'actions.nop()';
        });
        inputStateKeys.forEach(function (key) {
            resultMap[key] = "controller.state." + key;
        });
        resultMap['id'] = 'id';
        resultMap['fields'] = 'controller.fieldControllerMeta.fields';
        InitialControlTemplateGenerator.setEmptyValuesForFields(controller, resultMap);
        template = controller.meta.template.replace('\n', '');
        Mustache.parse(template, ['%{', '}']);
        template = Mustache.render(template, resultMap);
        return template;
    };
    InitialControlTemplateGenerator.setEmptyValuesForFields = function (controller, resultMap) {
        if (controller.fields) {
            for (var _i = 0, _a = Object.keys(controller.fields); _i < _a.length; _i++) {
                var key = _a[_i];
                resultMap[key] = 'controller.dummy';
                resultMap[key + "-name"] =
                    controller.fields[key] !== undefined
                        ? controller.fields[key]['metaFieldId'] !== undefined
                            ? controller.fields[key]['metaFieldId']['systemName']
                            : ''
                        : '';
                resultMap[key + "-id"] = '';
                resultMap[key + "-category"] =
                    controller.fields[key] !== undefined
                        ? controller.fields[key]['compoundCategorySystemName']
                        : '';
            }
        }
    };
    InitialControlTemplateGenerator.collectMustacheKeyData = function (controller) {
        var parsedArray = Mustache.parse(controller.meta.template, ['%{', '}']);
        var collectedData = [];
        for (var _i = 0, parsedArray_1 = parsedArray; _i < parsedArray_1.length; _i++) {
            var keyData = parsedArray_1[_i];
            if (keyData[0] === 'name') {
                collectedData.push(keyData[1]);
            }
            else if (keyData[0] === '#' || keyData[0] === '^') {
                // conditional template
                for (var _a = 0, _b = keyData[4]; _a < _b.length; _a++) {
                    var conditionTemplateData = _b[_a];
                    if (conditionTemplateData[0] === 'name') {
                        collectedData.push(conditionTemplateData[1]);
                    }
                }
            }
        }
        return collectedData;
    };
    InitialControlTemplateGenerator.getStateTemplateKeys = function (controller, formType) {
        var stateKeys = [];
        var templateKeys = InitialControlTemplateGenerator.collectMustacheKeyData(controller);
        var excludedKeys = [];
        for (var _i = 0, _a = Object.keys(controller.fields); _i < _a.length; _i++) {
            var key = _a[_i];
            excludedKeys.push(key + "-name");
            excludedKeys.push(key);
            excludedKeys.push(key + "-id");
            excludedKeys.push(key + "-category");
        }
        lodash_1.forIn(controller.actions, function (value, key) {
            excludedKeys.push(key);
        });
        if (controller.state) {
            controller.state = lodash_1.omit(controller.state, excludedKeys);
        }
        for (var _b = 0, templateKeys_1 = templateKeys; _b < templateKeys_1.length; _b++) {
            var keyName = templateKeys_1[_b];
            if (controller.state &&
                lodash_1.indexOf(excludedKeys, keyName) < 0 &&
                lodash_1.indexOf(stateKeys, keyName) < 0) {
                if (keyName.toLocaleLowerCase() === 'isreadonly') {
                    controller.state[keyName] = formType === idm_dynamic_layout_interpreter_1.FormType.VIEW;
                }
                else {
                    if (!controller.state.hasOwnProperty(keyName)) {
                        controller.state[keyName] = '';
                    }
                }
                stateKeys.push(keyName);
            }
        }
        return stateKeys;
    };
    //
    // public static readonly BINDING_KEYS_WITH_EMPTY_VALUES: string[] = [
    //     'ngmodel', 'value', 'currentlanguageid', 'valuechange', 'validations', 'actionnotifier',
    //     'data', 'items', 'checkeditems', 'change', 'rowitems', 'colsystemnames', 'transientfields',
    //     'headermessages', 'datemodel', 'isdeletable', 'iseditable', 'isaddable',
    //     'checked', 'form', 'subformkey', 'entity', 'ondocumentuploaded', 'ondocumentdownload',
    //     'ondocumentdelete', 'checkeditemid', 'name', 'click', 'tabledocupload', 'tabledocremove',
    // ];
    InitialControlTemplateGenerator.BINDING_KEYS_WITH_INIT_VALUES = [
        'languages',
        'id',
        'categoryname',
        'fieldsystemname',
        'categoryid',
    ];
    return InitialControlTemplateGenerator;
}());
exports.InitialControlTemplateGenerator = InitialControlTemplateGenerator;
//# sourceMappingURL=initial-control-template-generator.js.map